import React from 'react';
import styles from './MyToggle.module.css';

export default function MyToggle({
  name,
  label,
  checked,
  onChange,
  disabled = false,
  className = '',
  ...props
}) {
  return (
    <div className={`${styles.toggleWrapper} ${className}`}>
      <label htmlFor={name} className={styles.label}>
        <span className={styles.labelText}>{label}</span>
        <div className={`${styles.switch} ${checked ? styles.checked : ''} ${disabled ? styles.disabled : ''}`}>
          <input
            type="checkbox"
            id={name}
            name={name}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className={styles.input}
            {...props}
          />
          <span className={styles.slider}></span>
        </div>
      </label>
    </div>
  );
}
